import React from "react";
import { Map } from "immutable";
import { Badge } from "antd";

export class SaveProxy {
    handlers = new Map({});
    activated = new Map({});

    attach(id, handler) {
        this.handlers = this.handlers.set(id, handler);
        this.activated = this.activated.set(id, false);
    }

    detach(id) {
        this.handlers = this.handlers.remove(id);
    }

    activate(id) {
        this.activated = this.activated.set(id, true);
        if (this.hooks && this.hooks.length > 0) {
            this.hooks.map(_ => _(true, this.activated.size));
        }
    }
    hooks = [];
    hook(callback) {
        this.hooks.push(callback);
    }

    run() {
        this.handlers.forEach((_, id) => {
            if (this.activated.get(id)) {
                this.activated = this.activated.set(id, false);
                _();
            }
            if (
                !this.activated
                    .toList()
                    .reduce((agg, curr) => agg && curr, false)
            ) {
                this.hooks.map(_ => _(false, 0));
            }
        });
    }
}

const proxy = new SaveProxy();

export const proxyWrapper = (Comp, options = {}, customProxy) =>
    class extends React.Component {
        constructor(props) {
            super(props);
            this.proxy = customProxy || proxy;
            this.toggleState = this.toggleState.bind(this);
            this.proxy.hook(this.toggleState);
        }
        state = {
            disabled: true,
            count: 0
        };

        toggleState(value, count) {
            this.setState({
                disabled: !value,
                count: options.count ? count : 0
            });
        }

        render() {
            return (
                <Badge count={this.state.count}>
                    <Comp {...this.props} disabled={this.state.disabled} />
                </Badge>
            );
        }

        static displayName = `SaveProxyConnect(${Comp.displayName})`;
    };

export default proxy;
